export function formatDate (val, type = 1) {
  if (!val) return
  const date = new Date(val)
  const Y = date.getFullYear() + '-'
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  if (type === 1) {
    return Y + M + D + h + m + s
  } else if (type === 2) {
    return (Y + M + D).trim()
  }
}

export function addWorkDays (val, workDays) {
  let i = 0
  while (i < workDays) {
    val.setDate(val.getDate() + 1)
    i++
    if (val.getDay() === 0 || val.getDay() === 6) {
      i--
    }
  }
  val.setHours(0, 0, 0, 0)
  return val
}

export function isSameDay (date1, date2) {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
}
